// src/components/planning/ServiceCard/hooks/useServiceEditing.ts
import { useCallback } from 'react';

interface UseServiceEditingProps {
  serviceId: number;
  onEditSongs?: () => void;  // Added this prop as optional
}

export const useServiceEditing = ({ serviceId, onEditSongs }: UseServiceEditingProps) => {
  const handleEditSongs = useCallback(() => {
    console.log('Edit songs clicked for service:', serviceId);
    if (onEditSongs) {
      onEditSongs();
    }
  }, [serviceId, onEditSongs]);

  return {
    handleEditSongs
  };
};